<template>
  <div>
    <NavBarTop v-show="mostrarNavTop" />
    <NavBarLeft v-show="mostrarNavLeft" />
    <div class="text-xs sidebar-mini-xs" :class="[darkMode ? 'dark-mode' : '', $route.name === 'home' ? 'route-home' : '', requiresTwoFactorSetup ? 'two-factor-setup-mode' : '']">
      <transition name="fade-slide-rigth">
        <router-view :key="$route.path" />
      </transition>
    </div>
    <vue-progress-bar />
  </div>
</template>
<script>
import NavBarTop from "./components/layout/NavBarTop";
import NavBarLeft from "./components/layout/NavBarLeft";
import { isPublicAuthRoute } from "./utils/authRoutes";
export default {
  components: {
    NavBarTop,
    NavBarLeft,
  },
  
  data() {
    return {
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  computed: {
    darkMode() {
      return this.$store.getters.getDarkMode;
    },
    requiresTwoFactorSetup() {
      return this.$store.getters.requiresTwoFactorSetup;
    },
    mostrarNavTop() {
      return (
        this.$store.state.auth &&
        !this.requiresTwoFactorSetup &&
        this.$route.name !== "EnviarTicket"
      );
    },
    mostrarNavLeft() {
      return (
        this.$store.state.auth &&
        !this.requiresTwoFactorSetup &&
        this.$route.name != "home" &&
        this.$route.name !== "EnviarTicket"
      );
    },
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
      this.$router.afterEach((to) => {
      this.$Progress.finish();
      this.aplicarClaseRuta(to.name);
    });
  },
  watch: {
    '$route'(to) {
      this.aplicarClaseRuta(to.name);
    },
    darkMode(isDark) {
      document.body.classList.toggle('dark-mode', isDark);
    },
    requiresTwoFactorSetup: {
      immediate: true,
      handler(required) {
        document.body.classList.toggle('two-factor-setup-mode', !!required);
      },
    },
  },

  methods: {
    aplicarClaseRuta(name) {
      document.body.classList.toggle("route-home", name === "home");
      document.body.classList.toggle("route-enviar-ticket", name === "EnviarTicket");
    },

  /** Restaura sesión solo en rutas protegidas (recarga con cookie válida). */
    async restoreSessionIfNeeded() {
      await this.$store.dispatch("getUser");
      if (!this.$store.getters.isAuthenticated) {
        return;
      }

      const savedLineaNegocioId = this.$store.getters.getCurrentLineaNegocioId;
      if (savedLineaNegocioId) {
        await this.$store.dispatch("getMenus", savedLineaNegocioId);
      } else {
        await this.$store.dispatch("getMenus");
      }

      await this.$store.dispatch("getPermissions");
      await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
      await this.$store.dispatch("setRoutes");
    },
  },

  async mounted() {
    this.$Progress.finish();

    if (!isPublicAuthRoute(this.$route.name)) {
      await this.restoreSessionIfNeeded();
    }

    if (
      this.$store.getters.isAuthenticated &&
      this.$route.name === "LoginForm"
    ) {
      if (this.$store.getters.requiresTwoFactorSetup) {
        return this.$router.replace({ name: "PerfilUsuario" });
      }
      return this.$router.replace("/");
    }

    if (
      this.$store.getters.requiresTwoFactorSetup &&
      this.$route.name !== "PerfilUsuario"
    ) {
      return this.$router.replace({ name: "PerfilUsuario" });
    }
    this.aplicarClaseRuta(this.$route.name);
    // Aplicar tema claro/oscuro al body (navbar, sidebar y contenido)
    document.body.classList.toggle('dark-mode', this.$store.getters.getDarkMode);
  },
};
</script>

<style>
.bg-support {
  background: #153f75;
}

.bg-support-menu {
  background: #bad35c;
}

.bg-support-blue {
  background: #153f75;
  color: #fff;
}

.bg-support-green {
  background: #bad35c;
}

.bg-support-gradient {
  background: #153f75;
  background: -webkit-linear-gradient(to bottom right, #bad35c, #153f75);
  background: linear-gradient(to bottom right, #bad35c, #153f75);
}

.bg-support-blue-gradient {
  background: linear-gradient(to bottom right, #001871, #2980b9);
  background-size: 250% 250%;
  animation: gradientAnimation 7s ease infinite;
  color: #fff;
}

.fade-slide-rigth-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-rigth-enter,
.fade-slide-rigth-leave-to {
  transform: translateX(5%);
  opacity: 0;
}

.dark-vselect .vs__search::placeholder,
.dark-vselect .vs__dropdown-toggle,
.dark-vselect .vs__dropdown-menu,
.dark-vselect .vs__dropdown-option {
  background: #343a40;
  border: solid 1px #535b62;
  color: #fff;
  text-transform: lowercase;
  font-variant: small-caps;
}

.dark-vselect .vs__selected-options,
.dark-vselect .vs__selected,
.dark-vselect .vs__search,
.dark-vselect .vs__open {
  color: #fff;
}
.dark-vselect .vs__selected {
  background: #454d55;
}

.dark-vselect .vs__dropdown-option:hover {
  background: rgb(0, 4, 63);
}

.dark-vselect .vs__clear,
.dark-vselect .vs__open-indicator,
.dark-vselect .vs__deselect {
  fill: #fff;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background: #b7b5b5 !important;
}

.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100%);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.error-vselect .vs__dropdown-toggle {
  border: solid thin #dc3545;
}
.ok-vselect .vs__dropdown-toggle {
  border: solid thin #28a745;
}

/* Clase para campos de Estado - siempre borde verde */
.estado-select,
.estado-select.form-control,
.estado-select.form-control-sm,
select.estado-select,
select.estado-select.form-control,
select.estado-select.form-control-sm {
  border-color: #28a745 !important;
}

.estado-select.is-invalid,
.estado-select.is-invalid.form-control,
.estado-select.is-invalid.form-control-sm,
select.estado-select.is-invalid,
select.estado-select.is-invalid.form-control,
select.estado-select.is-invalid.form-control-sm {
  border-color: #28a745 !important;
}

/* Para v-select con clase estado-select */
.estado-select.v-select .vs__dropdown-toggle,
.v-select.estado-select .vs__dropdown-toggle {
  border-color: #28a745 !important;
  border-width: 1px !important;
}

.estado-select.v-select.is-invalid .vs__dropdown-toggle,
.v-select.estado-select.is-invalid .vs__dropdown-toggle,
.estado-select.v-select .vs__dropdown-toggle.is-invalid {
  border-color: #28a745 !important;
  border-width: 1px !important;
}

/* Asegurar que siempre sea verde, incluso con otras clases */
.estado-select.v-select.form-control-sm .vs__dropdown-toggle,
.v-select.estado-select.form-control-sm .vs__dropdown-toggle {
  border-color: #28a745 !important;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

.well {
  min-height: 20px;
  padding: 14px;
  margin-bottom: 10px;
  border: 2px solid #001871;
  border-radius: 5px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.well-legend {
  display: block;
  font-size: 20px;
  width: auto;
  min-width: 300px;
  padding: 2px 7px 2px 5px;
  line-height: unset;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

.ir-arriba {
  display: none;
  background-repeat: no-repeat;
  font-size: 20px;
  color: black;
  cursor: pointer;
  position: fixed;
  bottom: 80px;
  right: 8px;
  z-index: 2;
}

/* Sin menús: contenido a pantalla completa mientras configura 2FA */
body.two-factor-setup-mode .content-wrapper,
body.two-factor-setup-mode .main-header,
body.two-factor-setup-mode .main-footer {
  margin-left: 0 !important;
}
body.two-factor-setup-mode.sidebar-mini-xs .content-wrapper,
body.two-factor-setup-mode.sidebar-mini-xs .main-header,
body.two-factor-setup-mode.sidebar-mini-xs .main-footer {
  margin-left: 0 !important;
}

/* Cuando estamos en la ruta home o en el formulario público de tickets, eliminar los márgenes del sidebar */
body.route-home .content-wrapper,
body.route-home .main-header,
body.route-home .main-footer,
body.route-home .wrapper,
body.route-enviar-ticket .content-wrapper,
body.route-enviar-ticket .main-header,
body.route-enviar-ticket .main-footer,
body.route-enviar-ticket .wrapper {
  margin-left: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

/* Eliminar el margin-left que aplica sidebar-mini-xs en home y en el formulario de tickets */
body.route-home.sidebar-mini-xs .content-wrapper,
body.route-home.sidebar-mini-xs .main-header,
body.route-home.sidebar-mini-xs .main-footer,
body.route-enviar-ticket.sidebar-mini-xs .content-wrapper,
body.route-enviar-ticket.sidebar-mini-xs .main-header,
body.route-enviar-ticket.sidebar-mini-xs .main-footer {
  margin-left: 0 !important;
}

/* ===== Sidebar izquierdo (tema claro): verde corporativo que se note ===== */
.main-sidebar.sidebar-light {
  border-left: 4px solid #9bc04a;
}
.main-sidebar.sidebar-light .brand-link {
  border-bottom: 2px solid #bad35c;
  background: linear-gradient(180deg, rgba(186, 211, 92, 0.12) 0%, transparent 100%);
}
.main-sidebar.sidebar-light .brand-link .platform-title {
  color: #1a2e0a;
  font-size: 0.85rem;
  font-weight: 800;
  line-height: 1.15;
}
.main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu {
  background: linear-gradient(135deg, #c5e06b 0%, #bad35c 45%, #9bc04a 100%) !important;
  color: #1a2e0a !important;
  border-left: 4px solid #7fb83a;
  font-weight: 600;
  border-radius: 0 8px 8px 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu .nav-icon,
.main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu .right,
.main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu p {
  color: #1a2e0a !important;
}
.main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu:hover {
  background: linear-gradient(135deg, #bad35c 0%, #9bc04a 55%, #7fb83a 100%) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

/* ===== Tema oscuro: azul oscuro (no gris) + menú izquierdo más visible ===== */
body.dark-mode {
  background: #050d1f;
  color: #e4e6eb;
}
body.dark-mode .main-header {
  background: #153f75 !important;
  border-color: rgba(255,255,255,0.08);
}
/* Sidebar: más claro que el contenido y bien delimitado */
body.dark-mode .main-sidebar,
body.dark-mode .sidebar-container .main-sidebar {
  background: #0d1835 !important;
  border-right: 2px solid rgba(21, 63, 117, 0.6);
  box-shadow: 4px 0 20px rgba(0,0,0,0.25);
}
body.dark-mode .main-sidebar .brand-link {
  color: #fff !important;
  border-bottom: 1px solid rgba(66, 113, 171, 0.4);
  background: rgba(21, 63, 117, 0.2);
}
body.dark-mode .main-sidebar .brand-link .platform-title {
  color: #fff !important;
}
/* Títulos de sección (Flota, Operación…): fondo y texto claros, sin verde lima */
body.dark-mode .main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu {
  background: #0f1f3d !important;
  color: #e4e6eb !important;
  border-left: 3px solid #153f75;
  border-radius: 0 6px 6px 0;
}
body.dark-mode .main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu .nav-icon,
body.dark-mode .main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu .right,
body.dark-mode .main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu p {
  color: #e4e6eb !important;
}
body.dark-mode .main-sidebar .nav-sidebar > .nav-item > .nav-link.bg-support-menu:hover {
  background: rgba(21, 63, 117, 0.5) !important;
  color: #fff !important;
}
body.dark-mode .main-sidebar .nav-sidebar .nav-link {
  color: #c5d0dc !important;
}
body.dark-mode .main-sidebar .nav-sidebar .nav-link:hover {
  background: rgba(21, 63, 117, 0.35);
  color: #fff !important;
}
body.dark-mode .main-sidebar .nav-treeview .nav-link.bg-support {
  background: #153f75 !important;
  color: #fff !important;
}
/* Búsqueda del sidebar: bien visible */
body.dark-mode .main-sidebar .form-control-sidebar {
  background: #0f1830;
  border: 1px solid rgba(66, 113, 171, 0.5);
  color: #e4e6eb;
}
body.dark-mode .main-sidebar .form-control-sidebar::placeholder {
  color: #8b9cb0;
}
body.dark-mode .main-sidebar .btn-sidebar {
  background: #153f75;
  border-color: rgba(66, 113, 171, 0.5);
  color: #fff;
}
body.dark-mode .main-sidebar .sidebar-footer {
  border-top: 1px solid rgba(66, 113, 171, 0.3);
}
body.dark-mode .content-wrapper {
  background: #050d1f !important;
}
body.dark-mode .content-header,
body.dark-mode .content-header h1 {
  color: #e4e6eb !important;
}
body.dark-mode .content-header .breadcrumb {
  background: transparent;
  color: #9ca3af;
}
body.dark-mode .content-header .breadcrumb-item a {
  color: #6b9bd1;
}
body.dark-mode .card {
  background: #0d1526;
  border: 1px solid rgba(66, 113, 171, 0.25);
  color: #e4e6eb;
}
body.dark-mode .card-header {
  background: #0f1830;
  border-bottom: 1px solid rgba(66, 113, 171, 0.25);
  color: #e4e6eb;
}
body.dark-mode .card-body {
  color: #e4e6eb;
}
body.dark-mode .table {
  color: #e4e6eb;
}
body.dark-mode .table thead th {
  background: #0f1830;
  border-color: rgba(66, 113, 171, 0.2);
  color: #e4e6eb;
}
body.dark-mode .table td,
body.dark-mode .table th {
  border-color: rgba(66, 113, 171, 0.15);
}
body.dark-mode .table-hover tbody tr:hover {
  background: rgba(21, 63, 117, 0.12);
}
body.dark-mode .form-control,
body.dark-mode .form-control:focus {
  background: #0d1526;
  border: 1px solid rgba(66, 113, 171, 0.3);
  color: #e4e6eb;
}
body.dark-mode .form-control::placeholder {
  color: #9ca3af;
}
body.dark-mode .small-box {
  background: #0d1526 !important;
  border: 1px solid rgba(66, 113, 171, 0.25);
}
body.dark-mode .info-box {
  background: #0d1526;
  border: 1px solid rgba(66, 113, 171, 0.25);
}
body.dark-mode .dropdown-menu {
  background: #0d1526;
  border: 1px solid rgba(66, 113, 171, 0.25);
}
body.dark-mode .dropdown-item {
  color: #e4e6eb;
}
body.dark-mode .dropdown-item:hover {
  background: rgba(21, 63, 117, 0.3);
  color: #fff;
}
body.dark-mode .dropdown-divider {
  border-color: rgba(66, 113, 171, 0.2);
}
</style>
